<template>
    <div>
        <div class="mb-4">
            <div class="d-flex justify-content-between text-align-center">
                <BButtonGroup>
                    <BButton variant="primary" @click="filterActive = !filterActive">
                        <i class="fad fa-filter mr-2" /> <span class="font-weight-500">Filtr</span>
                    </BButton>
                    <BButton variant="danger" @click="resetFilters" v-if="isFilterUsed">
                        <i class="far fa-times" />
                    </BButton>
                </BButtonGroup>
            </div>

            <BCollapse :visible="filterActive || isFilterUsed" class="mt-3 bg-little-gray p-3">
                <BForm @submit.prevent="onFilterSubmit">
                    <BRow class="mb-3">
                        <BCol>
                            <BFormGroup class="mb-0" label-size="sm" label-cols-sm="5" label-cols-md="4"
                                label-cols-lg="3" label="EAN/EIC:" label-align-sm="right" label-class="font-weight-700"
                                label-for="filter-ean">
                                <BFormInput id="filter-ean" size="sm" v-model="filterRequest.filter.ean" />
                            </BFormGroup>
                        </BCol>
                        <BCol>
                            <BFormGroup class="mb-0" label-size="sm" label-cols-sm="5" label-cols-md="4"
                                label-cols-lg="3" label="Adresa:" label-align-sm="right" label-class="font-weight-700"
                                label-for="filter-address">
                                <BFormInput id="filter-address" size="sm" v-model="filterRequest.filter.address" />
                            </BFormGroup>
                        </BCol>
                    </BRow>
                    <BRow class="mb-3">
                        <BCol>
                            <BFormGroup class="mb-0" label-size="sm" label-cols-sm="5" label-cols-md="4"
                                label-cols-lg="3" label="Zákazník:" label-align-sm="right" label-class="font-weight-700"
                                label-for="filter-customer">
                                <BFormInput id="filter-customer" v-model="filterRequest.filter.customer" size="sm" />
                            </BFormGroup>
                        </BCol>
                        <BCol>
                            <BFormGroup class="mb-0" label-size="sm" label-cols-sm="5" label-cols-md="4"
                                label-cols-lg="3" label="Vlastník nemovitosti:" label-align-sm="right"
                                label-class="font-weight-700" label-for="filter-propertyOwner">
                                <BFormInput id="filter-propertyOwner" v-model="filterRequest.filter.propertyOwner"
                                    size="sm" />
                            </BFormGroup>
                        </BCol>
                    </BRow>
                    <BRow class="mb-3">
                        <BCol>
                            <BFormGroup class="mb-0" label-size="sm" label-cols-sm="5" label-cols-md="4"
                                label-cols-lg="3" label="Komodita:" label-align-sm="right" label-class="font-weight-700"
                                label-for="filter-commodity">
                                <BFormSelect v-model="filterRequest.filter.commodity" name="type" id="filter-commodity"
                                    value-field="id" text-field="text" size="sm" :options="commodity.arrayList()">
                                    <template #first>
                                        <BFormSelectOption :value="null">-- Vybrat --</BFormSelectOption>
                                    </template>
                                </BFormSelect>
                            </BFormGroup>
                        </BCol>
                        <BCol />
                    </BRow>
                    <BRow>
                        <BButton type="submit" variant="primary" size="sm">Vyhledat</BButton>
                    </BRow>
                </BForm>
            </BCollapse>
        </div>
        <div>
            <TableLoading v-if="isLoading && !hasRecords" class="mb-4" />
            <TableWithoutRecords v-else-if="!isLoading && !hasRecords" class="mb-4" />

            <div v-else>
                <div v-for="(record, i) in records" :key="record.id"
                    :class="['record-item px-2 border-bottom border-dark', { 'even-li-bg': i % 2 === 0 }]">
                    <div
                        class="d-flex justify-content-between align-items-center border-light border-bottom py-3 pointer">
                        <div>
                            EAN / EIC
                        </div>
                        <div>
                            {{ record.ean }}
                        </div>
                    </div>
                    <div
                        class="d-flex justify-content-between align-items-center border-light border-bottom py-3 pointer">
                        <div>
                            Adresa
                        </div>
                        <div class="mw-50">
                            {{ record.address }}
                        </div>
                    </div>
                    <div
                        class="d-flex justify-content-between align-items-center border-light border-bottom py-3 pointer">
                        <div>
                            Zákazník
                        </div>
                        <div>
                            {{ record.customer }}
                        </div>
                    </div>
                    <div
                        class="d-flex justify-content-between align-items-center border-light border-bottom py-3 pointer">
                        <div>
                            Majitel nemovitosti
                        </div>
                        <div>
                            {{ record.propertyOwner }}
                        </div>
                    </div>

                    <div
                        class="d-flex justify-content-between align-items-center border-light border-bottom py-3 pointer">
                        <div>
                            Detail OM
                        </div>

                        <div v-if="record.floorNumber">
                            Patro {{ record.floorNumber }}
                        </div>

                        <div v-if="record.apartmentNumber">
                            Byt {{ record.apartmentNumber }}
                        </div>
                    </div>
                </div>
            </div>



        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import Commodity from "@/Model/Enum/commodity"
import SimpleFormRequest from "../../../NewModel/Common/SimpleFormRequest"
import TableLoading from "@/Module/Common/UI/Table/TableLoading.vue"
import TableWithoutRecords from "@/Module/Common/UI/Table/TableWithoutRecords.vue"

export default {
    data() {
        return {
            filterRequest: this.buildFilterRequest(),
            filterActive: false,
            commodity: Commodity,
            selectedSupplyPoints: [],
            records: [],
            hasRecords: false
        }
    },

    components: {
        TableLoading,
        TableWithoutRecords,
    },

    computed: {
        ...mapGetters({
            user: 'auth/getUser',
            isLoading: 'supplyPoint/isLoading',
            totalRecords: 'supplyPoint/getTotalSupplyPoints',
        }),
        gridName: () => '_MobilesupplyPointGridFilter',
        isFilterUsed() {
            const f = this.filterRequest.filter;
            return !!(f.ean || f.commodity || f.customer || f.propertyOwner || f.address);
        },
    },

    mounted() {
        this.filterUpdated()
    },

    methods: {
        checkMapPoint(_id) {
            return this.selectedSupplyPoints.findIndex((item) => item.id === _id) === -1;
        },

        buildFilterRequest() {
            return new SimpleFormRequest({
                ean: '',
                commodity: null,
                customer: '',
                propertyOwner: '',
                address: '',
            }, "ean", 10, false)
        },

        gridUpdated(ctx) {
            if (ctx) {
                this.filterRequest.sortBy = ctx.sortBy
                this.filterRequest.sortDesc = ctx.sortDesc
                this.saveFilter()
            }
        },

        saveFilter() {
            if (this.user.filterSave) {
                this.$cookies.set(this.gridName, this.filterRequest.store())
            }
        },

        filterUpdated(resetPage = false) {
            if (resetPage) {
                this.filterRequest.currentPage = 1
            }
            this.saveFilter()

            this.$store.dispatch("supplyPoint/getFilteredRecords", this.filterRequest)
                .then((response) => {
                    this.records = response || []
                    this.hasRecords = response.length > 0
                })
                .catch(() => {
                    this.data = []
                })
        },

        resetFilters() {
            this.filterActive = false
            this.filterRequest = this.buildFilterRequest()
            this.filterUpdated()
        },

        onFilterSubmit() {

            this.filterUpdated();
        },
    },
}
</script>